import { render } from "./TopSearch.vue?vue&type=template&id=b0bc78e6&lang=pug"
import script from "./TopSearch.vue?vue&type=script&lang=js"
export * from "./TopSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__